import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';

export default function SecurityDashboard() {
  const token = useSelector((state) => state.auth.token);
  const [incidents, setIncidents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
        const response = await fetch(`${baseUrl}/api/audit/security-incidents/`, {
          headers: { Authorization: `Token ${token}` },
        });
        if (!response.ok) throw new Error('Unable to load security incidents.');
        const payload = await response.json();
        setIncidents(payload.results || payload);
      } catch (loadError) {
        setError(loadError.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [token]);

  if (loading) return <Box p={4} textAlign="center"><CircularProgress /></Box>;
  if (error) return <Box p={3}><Typography color="error">{error}</Typography></Box>;

  return <Paper style={{ padding: 16, borderRadius: 8 }}>
    <Typography variant="h6" style={{ color: '#002D55', fontWeight: 600, marginBottom: 12 }}>Security incidents</Typography>
    <Table size="small"><TableHead><TableRow><TableCell>Time</TableCell><TableCell>Severity</TableCell><TableCell>Signal</TableCell><TableCell>Clinic</TableCell><TableCell>Location</TableCell><TableCell>Status</TableCell></TableRow></TableHead>
      <TableBody>{incidents.length ? incidents.map((incident) => <TableRow key={incident.id}><TableCell>{new Date(incident.created_at).toLocaleString()}</TableCell><TableCell>{incident.severity}</TableCell><TableCell>{incident.category}</TableCell><TableCell>{incident.care_provider_name || 'Platform'}</TableCell><TableCell>{[incident.city, incident.country].filter(Boolean).join(', ') || 'Unavailable'}</TableCell><TableCell>{incident.status}</TableCell></TableRow>) : <TableRow><TableCell colSpan={6} align="center">No security incidents.</TableCell></TableRow>}</TableBody>
    </Table>
  </Paper>;
}